import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import { Row, Col } from "reactstrap";
import size from "lodash/size";
import useUpsert from "./use-upsert";
import Select from "@src/@core/components/fields/react-select/select";
import { TIMEZONE } from "@src/utility/constants/panel/common";
import PasswordField from "@src/@core/components/fields/password-field";
import { ORG_STATUS_OPTIONS } from "../misc/constants";

const UpsertOrganizations = (props) => {
    const { modalConfig, handleModal } = props;
    const isEdit = !!size(modalConfig.row);

    const { onSubmit, methods, updateLoading, isDirty } = useUpsert(props);
    const {
        control,
        formState: { errors }
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Organization Details",
                desc : "Enter the basic details of the organization"
            },
            rightChild: (
                <Row>
                    <Col md={6}>
                        <InputField
                            id="name"
                            name="name"
                            label="Organization Name"
                            required
                            control={control}
                            errors={errors}/>
                    </Col>

                    <Col md={6}>
                        <Select
                            options={ORG_STATUS_OPTIONS}
                            errors={errors}
                            label="Status"
                            name="status"
                            id="status"
                            control={control}/>
                    </Col>
                </Row>
            )
        },
        {
            leftChild: {
                title: "Admin Details",
                desc : "Enter the admin user details for this organization"
            },
            rightChild: (
                <Row>
                    <Col md={6}>
                        <InputField
                            id="admin_name"
                            name="admin_name"
                            label="Admin Name"
                            required
                            control={control}
                            errors={errors}
                            disabled={isEdit}/>
                    </Col>
                    <Col md={6}>
                        <InputField
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            required
                            control={control}
                            errors={errors}
                            disabled={isEdit}/>
                    </Col>
                    <Col md={6}>
                        <InputField
                            id="title"
                            name="title"
                            label="Title"
                            control={control}
                            errors={errors}
                            disabled={isEdit}/>
                    </Col>
                    <Col md={6}>
                        <Select
                            options={TIMEZONE}
                            errors={errors.region}
                            label="Timezone"
                            name="region.timezone"
                            id="timezone"
                            control={control}
                            disabled={isEdit}/>
                    </Col>
                    <Col md={6}>
                        <InputField
                            id="phone"
                            name="phone"
                            label="Phone"
                            control={control}
                            errors={errors}
                            disabled={isEdit}/>
                    </Col>
                    <Col md={6}>
                        <PasswordField
                            id="password"
                            name="password"
                            className="mb-1"
                            label="Password"
                            errors={errors}
                            control={control}
                            disabled={isEdit}/>
                    </Col>
                </Row>
            )
        }
    ];

    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Organization`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit
            }}
            type="extraLarge"
            isDirty={isDirty}
            loading={updateLoading}
            handleModal={handleModal}
            isOpen={modalConfig.isOpen}/>
    );
};

export default UpsertOrganizations;
